import { CircleAlert } from 'lucide-react';

interface FieldMessageProps { field: string; message?: string | null }

// Empty fields render no spacer; only actual feedback takes up room.
export default function FieldMessage({ field, message }: FieldMessageProps) {
  if (!message) return null;
  return <p id={`auth-${field}-error`} role="status" aria-live="polite" aria-atomic="true"
    className="auth-field-message mt-1 flex items-start gap-1.5 text-[11px] leading-4">
    <CircleAlert size={13} className="mt-0.5 shrink-0" aria-hidden="true" />
    <span>{message}</span>
  </p>;
}
